import { useQuery } from "@tanstack/react-query";
import { getRegion } from "../../service/query/auth";

export const useGetRegion = (id) => {
  const region = useQuery({
    queryKey:["get_all_region", id],
    queryFn:async()=> getRegion({id}),
    enabled: !!id,
    staleTime: 0,


  },
  
);
  return {data:region?.data?.data,  ...region,}
};